// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1aIg1","list":"BalanceDue_list__2vhJ2","listRow":"BalanceDue_listRow__3ujvf","total":"BalanceDue_total__-zS_B"};